export default "__VITE_ASSET__BIDRH3bc__"